export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_ITEMS = [
  { name: 'news', text: 'Новости' },
  { name: 'brands', text: 'Бренды' },
  { name: 'faq', text: 'FAQ' },
  { name: 'products', text: 'Товары' },
  { name: 'feedback', text: 'Обратная связь' },
  { name: 'projects', text: 'Проекты' },
];
